import React from 'react';

export const RegistrationErrorContext = React.createContext(null);
const Provider = (props) => {
  const { children } = props;
  const [dbEmptyError, setDbEmptyError] = React.useState(false);
  const [landingImageError, setLandingImageError] = React.useState(false);
  const [regEmptyError, setRegEmptyError] = React.useState(false);
  const [tcError, setTcError] = React.useState(false);
  const [methodError, setMethodError] = React.useState(false);
  // const [guestCheckoutEmptyError, setGuestCheckoutEmptyError] =
  //   React.useState(false);
  // const [reInformationEmptyError, setReInformationEmptyError] =
  //   React.useState(false);
  // const [tcEmptyError, setTcEmptyError] = React.useState(false);
  const resetStatus = () => {
    setDbEmptyError(false);
    setLandingImageError(false);
    setRegEmptyError(false);
    setTcError(false);
    setMethodError(false);
  };
  return (
    <RegistrationErrorContext.Provider
      value={{
        methodError,
        setMethodError,
        dbEmptyError,
        setDbEmptyError,
        landingImageError,
        setLandingImageError,
        regEmptyError,
        setRegEmptyError,
        tcError,
        setTcError,
        resetStatus,
      }}>
      {children}
    </RegistrationErrorContext.Provider>
  );
};
export default Provider;
